import React, { Component } from 'react';
import axios from "axios";
import {TextField, Autocomplete, Drawer, Paper, IconButton, Container, Grid, FormControl, InputLabel, Button, Table, TableHead, TableRow, TableCell, TableBody} from '@mui/material';
import Api from "../../customlib/Api";
import Modal from "react-bootstrap/Modal";
// import { Button, Container, Form, FormGroup, Label, ButtonGroup, Table} from 'reactstrap';
import { FormControlLabel, MenuItem, Select, Switch } from '@mui/material';
import './SettingContact.css'; 
import Global from '../../customlib/Global';
import { Add, Delete, Edit, Refresh } from '@mui/icons-material';

class CheckpointSettings extends Component {

    constructor(props) {
      super(props);
      this.state = {
        item: this.emptyCustomer,
        sales: []
      };
      // this.handleChange = this.handleChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
    }
  
    state = { 
        contacts : [],
        sales : [],
        contactSelectedToUpdate: [],
        checkAll : null,
        salesData: [],
        selectedSales : {},//id = id, lavenderSalesId, lavenderSalesName, salesType
        id: 0,
        lavenderSalesId: 0,
        lavenderSalesName: "",
        salesType: "Acquisition",
        checkpointCount: 24,
        bottom: false,
        salesInfo: {}, //id = id, lavenderSalesId, lavenderSalesName, salesType
        showDeleteSalesLavenderDialog: false,
        idDelete:0,
        idSalesDelete:0,
        nameSalesDelete:"",
        allowReceiveLeads: 1,
        isNightShift: false,
        currentEditUser: {
          _id: "", 
          userId: 0, 
          userName: "", 
          userType: "OTHER", 
          enabled: true,
          appProfileId: Global.getAppProfile()._id,
          checkpointCount: 24
        }
    }

    componentDidMount() {
        this.getCheckpointUsers();
        this.getUserList();
        this.setState({id: 0});
        
    }

    getUserList = () => {
        axios
        // .post(Api.getSalesTeleUserList(), {}, Api.getRequestHeader())
        .post(Api.allUserList(), {}, Api.getRequestHeaderJsonNew())
        .then((response) => {
            console.log("SALESTELEUSER : ", response.data.data);
            this.setState({salesData: response.data.data});
        })
        .catch((error) => {
            console.error("There was an error!", error);
        });
    };

    getCheckpointUsers = () => {
      axios
        .post(Api.checkpointUserList(), {appProfileId: Global.getAppProfile()._id}, Api.getRequestHeader())
        .then((response) => {
            console.log("SALESCHATLIST : ", response.data.data);
            this.setState({sales: response.data.data});
        })
        .catch((error) => {
            console.error("There was an error!", error);
        });
    };


    // handleAddButton = () => {
    //     let newData = 
    //     {
    //         id: 0,
    //         lavenderSalesId: 0,
    //         lavenderSalesName: "",
    //         salesType: "Acquisition"
    //     };

    //     const sales = [...this.state.contacts, newData];

    //     this.setState({contacts: []}, ()=>{
    //         this.setState({contacts: sales});
    //     });

    // }

    handleUserTypeChange = (event) => {
      let editUser = this.state.currentEditUser;
      editUser.userType = event.target.value;
      this.setState({
          currentEditUser: editUser
      });
      
    };

    handleCheckpointCountChange = (event) => {
      let editUser = this.state.currentEditUser;
      editUser.checkpointCount = event.target.value;
      this.setState({
          currentEditUser: editUser
      });
      
    };

    handleUserSelectionChanged = (userName) => {
      const userData = [...this.state.salesData];
      let selected = userData.filter((sales) => sales.name===userName);
      console.log("FINDSELECTION : ", selected);

      if(selected.length > 0){
          let newData = JSON.parse(JSON.stringify(selected[0]));
          
          newData.lavenderSalesId = selected.id;

          let editUser = this.state.currentEditUser;
          editUser.userId = selected[0].id;
          editUser.userName = selected[0].name;
          this.setState({
            selectedSales: newData,
            currentEditUser: editUser
          });

          console.log("currentEditUser", editUser);
      }

  }

  editCheckpointUser = (userData) => {
    console.log("USER_DATA", userData);
    this.setState({currentEditUser: userData, 'bottom': true});
  }

  addCheckPointUser = () => {
    const newUserData = { 
      appProfileId: Global.getAppProfile()._id,
      userId: 0,
      userName: "",
      enabled: true,
      userType: "OTHER",
      _id: ""
    }
    this.setState({currentEditUser: newUserData, 'bottom': true});
  }


  cancel(){
    this.setState({ ...this.state, 'bottom': false });
  }

  async handleSubmit(event) {
    // event.preventDefault();
    
    var params = {
        id: this.state.currentEditUser._id, 
        userId: this.state.currentEditUser.userId, 
        userName: this.state.currentEditUser.userName, 
        userType: this.state.currentEditUser.userType, 
        enabled: this.state.currentEditUser.enabled,
        appProfileId: Global.getAppProfile()._id,
        checkpointCount: this.state.currentEditUser.checkpointCount
      };

    console.log("PARAMS", params);
    // return;
    axios
      .post(Api.saveCheckpointUser(), params, 
        Api.getRequestHeader())
      .then((response) => {
        console.log("doSaveSales : ", response.data);
        let responseData = response.data;
        if(responseData.success){
            console.log(responseData);
            // this.props.history.push('/setting');
            this.getCheckpointUsers();
            // return;
            
            this.setState({ ...this.state, 'bottom': false });
        }
        // this.setState({contacts: response.data.data});
        
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  handleRemoveSales = () => {
      console.log(this.state.idDelete);
      console.log(this.state.idSalesDelete);

    axios
    .post(Api.deleteCheckpointUser(), {id: this.state.currentEditUser._id, appProfileId: this.state.currentEditUser.appProfileId}, Api.getRequestHeader())
    .then((response) => {
      console.log("doSaveSales : ", response.data);
      let responseData = response.data;
      if(responseData.success){
          console.log(responseData);
          this.getCheckpointUsers();
          this.handleCloseLogoutDialog();
      }
      
    })
    .catch((error) => {
      console.error("There was an error!", error);
    });
  }

  handleRemoveSalesDialog = (userData) => {

    this.setState({ 
      showDeleteSalesLavenderDialog: true,
      currentEditUser: userData
    });


  }

  handleSwitchLeads = () => {
    let allowLeads = 0;
    if(this.state.allowReceiveLeads === 1){
      allowLeads = 0;
    }else{
      allowLeads = 1;
    }

    this.setState({allowReceiveLeads: allowLeads});

  }

  handleSwitchNightShift = () => {
    let enabled = false;
    if(this.state.currentEditUser.enabled === true){
      enabled = false;
    }else{
      enabled = true;
    }

    const currentUser = this.state.currentEditUser;
    currentUser.enabled = enabled;

    this.setState({currentEditUser: currentUser});

  }

  handleCloseLogoutDialog = () => {
    this.setState({ showDeleteSalesLavenderDialog: false });
  };
    
    render() { 

      const { sales  } = this.state;

      const toggleDrawer = (anchor, open) => (event) => {
        
        // console.log('this.state.id=> '+this.state.id);
        // if(this.state.id === 0){
        //   // this.setState({
        //     this.state.salesType = 'Acquisition';
        //     this.state.allowReceiveLeads = 1;
        //     // }); 
        // }

        // if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
        //   return;
        // }

         
        // if(open === false){
          
        //   this.state.id = 0;
        //   this.state.lavenderSalesName = '';
        //   // if(this.state.salesType === ''){
        //     // this.state.salesType = 'Acquisition';
        //   // }else{
        //     this.state.salesType = '';
        //   // }

        //   // this.setState({ id: 0, lavenderSalesName: "", salesType: "", [anchor]: open });

        // }else{
        //   if(open === true && this.state.id === ''){
        //     // this.setState({
        //       this.state.salesType = 'Acquisition';
        //       // [anchor]: open
        //       // }); 
        //   }
        // }

      
        this.setState({[anchor]: open });
      };
 

        return (
          <Paper style={{padding: 20}}>
            <div>
              {/* <AppNavbar/> */}

              <div>

                <Modal
                  show={this.state.showDeleteSalesLavenderDialog}
                  onHide={this.handleCloseLogoutDialog}
                  backdrop="static"
                  keyboard={false}>
                  <Modal.Header closeButton>Konfirmasi</Modal.Header>
                  <Modal.Body>Yakin akan menghapus  {this.state.nameSalesDelete}?</Modal.Body>
                  <Modal.Footer>
                    <span onClick={this.handleRemoveSales} className="btn btn-danger">
                      Ya  
                    </span>
                    <span
                      onClick={this.handleCloseLogoutDialog}
                      className="btn btn-warning" >
                      Batalkan
                    </span>
                  </Modal.Footer>
                </Modal>
                
                  <React.Fragment key={'bottom'}>
                    
                    <Drawer width='40%' anchor={'right'} open={this.state['bottom']} onClose={toggleDrawer('bottom', false)}>
                      {/* {list(anchor)} */}
                      <div 
                        role="presentation"
                        // onClick={toggleDrawer('bottom', false)}
                        // onKeyDown={toggleDrawer('bottom', false)}
                      >
                        
                        <div className="col-12 text-left" style={{paddingTop: 8,}}>
                          <Container>
                              <h1>Input Salesman</h1>
                              <hr/>
                              {/* <Form onSubmit={this.handleSubmit}> */}

                              <Grid container spacing={1}>
                                <Grid item xs={12}>
                                  {(this.state.salesData && this.state.salesData.length > 0) ? 
                                    <Autocomplete
                                        labelId="nama-sales"
                                        id="free-solo-2-demo"
                                        // disableClearable
                                        freeSolo 
                                        options={this.state.salesData.map((option) => {
                                            // console.log("LABEL : ", option);
                                            return String(option.name);
                                        })}
                                        fullWidth
                                        onChange={(event, newValue) => {
                                            // console.log("NEWVALUE : ", event);
                                            this.handleUserSelectionChanged(newValue);
                                        }} 
                                        // value={this.state.contactData.lavenderSalesName}
                                        value={this.state.currentEditUser !== undefined ? this.state.currentEditUser.userName : ""}
                                        renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Nama Sales"
                                            // margin="0"
                                            variant="outlined"
                                            InputProps={{ ...params.InputProps, type: 'search' }}
                                            fullWidth
                                        />
                                        )}
                                        size='small'
                                    />
                                  : 
                                  <></>
                                }
                                </Grid>
                                <Grid item xs={12}>
                                  <FormControl variant="outlined" fullWidth>
                                    <InputLabel for="lastname">Sales tipe </InputLabel>
                                    <Select
                                        labelId="demo-simple-select-outlined-label"
                                        id="demo-simple-select-outlined"
                                        value={this.state.currentEditUser !== undefined ? this.state.currentEditUser.userType : ""}
                                        onChange={this.handleUserTypeChange}
                                        label="Tipe Sales"
                                        fullWidth
                                        size='small'>
                                        <MenuItem value={"CS"}>Customer Service</MenuItem>
                                        <MenuItem value={"SALES"}>Sales</MenuItem>
                                        <MenuItem value={"PURCHASING"}>Purchasing</MenuItem>
                                        <MenuItem value={"OTHER"}>Other</MenuItem>
                                    </Select>
                                  </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={12} sx={{pt: "10px"}}>
                                  <FormControl fullWidth size='small'>
                                    <InputLabel id="checkpoint_count_labelid">Jumlah checkpoint</InputLabel>
                                    <Select
                                        labelId="checkpoint_count_labelid"
                                        id="checkpoint_count_cb"
                                        value={this.state.currentEditUser !== undefined ? this.state.currentEditUser.checkpointCount : 24}
                                        onChange={this.handleCheckpointCountChange}
                                        label="Jumlah Checkpoint"
                                        size='small'
                                        fullWidth>
                                          {
                                            [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24].map(item => {
                                              return (
                                                <MenuItem value={item}>{item} kali checkpoint</MenuItem>
                                              );
                                            })
                                          }
                                    </Select>
                                  </FormControl>
                                </Grid>
                                <Grid item xs={12}>
                                  <FormControlLabel
                                    label= {this.state.currentEditUser !== undefined && this.state.currentEditUser.enabled === true ? "Aktif" : "Tidak aktif"}
                                    control={
                                      <Switch
                                        checked={this.state.currentEditUser !== undefined && this.state.currentEditUser.enabled === true}
                                        onChange={this.handleSwitchNightShift}
                                        name="switchNightShift"
                                        // color="primary"
                                        size='small'
                                      />
                                    }
                                    
                                  />
                                </Grid>
                                <Grid item xs={12}>
                                  <Grid container spacing={1}>
                                      <Grid item xs={6}>
                                          <Button fullWidth variant='contained' color="primary" onClick={this.handleSubmit}>Save</Button>
                                      </Grid>
                                      <Grid item xs={6}>
                                          <Button fullWidth variant='contained' color="secondary" onClick={() => this.cancel()} >Cancel</Button>
                                      </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                              
                              {/* </Form> */}
                          </Container>
                            
                          </div>
                      </div>
                          
  

                    </Drawer>
                  </React.Fragment>
                
              </div>

              {/* <TemporaryDrawer/> */}
          
              <Container fluid> 
                <div className="float-right"> 
                  {/* <Button color="success" tag={Link} to="/addsales">Add Sales</Button> &nbsp; */}
                  <Button variant='contained' color="primary" onClick={this.getCheckpointUsers} sx={{mr: "10px"}}><Refresh sx={{mr: "10px"}} /> Reload</Button>
                  <Button variant='contained' color="success" onClick={this.addCheckPointUser}><Add sx={{mr: "10px"}} /> Add Checkpoint User </Button>
                </div>
                <div>
                  <h3>User List</h3>
                </div>
                <Table size='small'>
                  <TableHead>
                    <TableRow>
                      <TableCell width="20%">User Name</TableCell> 
                      <TableCell width="20%">User Type</TableCell> 
                      <TableCell width="10%">Enabled</TableCell> 
                      <TableCell width="10%">Checkpoint</TableCell> 
                      <TableCell width="10%">Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {
                      sales.map(saless => {
                        return <TableRow key={saless._id}>
                            <TableCell style={{whiteSpace: 'nowrap'}}>{saless.userName}</TableCell> 
                            <TableCell style={{whiteSpace: 'nowrap'}}>{saless.userType}</TableCell> 
                            <TableCell style={{whiteSpace: 'nowrap'}}>{saless.enabled === true ? "YES" : "NO"}</TableCell> 
                            <TableCell style={{whiteSpace: 'nowrap'}}>{saless.checkpointCount ?? "-"}</TableCell> 
                            <TableCell>
                                <IconButton size='small' color='primary' onClick={ () => this.editCheckpointUser(saless)}><Edit /></IconButton>
                                {/* <Button size="sm" color="danger" onClick={() => this.handleRemoveSales(saless.id, saless.lavenderSalesId)}>Delete</Button> */}
                                <IconButton size="small" color="error" onClick={() => this.handleRemoveSalesDialog(saless)}><Delete /></IconButton>
                            </TableCell>
                        </TableRow>
                      })
                    }
                  </TableBody>
                </Table>
              </Container>
            </div>
          </Paper>
        );

    }
}

export default CheckpointSettings;
